// const API_BASE = 'https://beta-hwc.track360.net.in/'
// const AUTH_BASE = 'https://beta-hwc.track360.net.in/'
const API_BASE = 'https://highway-api.track360.net.in/'
const AUTH_BASE = 'https://highway-api.track360.net.in/'
// console.log("Using API BASE as " + API_BASE)
// console.log("Using AUTH BASE as " + AUTH_BASE)
   

const apiendpoints = {
    api_base: API_BASE,
    api_base_noslash: API_BASE.slice(0, -1),
    auth_base: AUTH_BASE,
    auth_base_noslash: AUTH_BASE.slice(0, -1),

    // Accounts
    login: AUTH_BASE + 'accounts/api/login/',
    logout: AUTH_BASE + 'accounts/api/logout/',
    forgot_password: AUTH_BASE + 'accounts/api/reset-password/',
    forgot_password_validate: AUTH_BASE + 'accounts/api/reset-password/validate/',
    profile: AUTH_BASE + 'dashboard/profile/',
    get_users: API_BASE + 'dashboard/users/browse/',
    user_profile: API_BASE + 'accounts/user/',
    user_role: API_BASE + 'accounts/user/role/',
    sign_up: API_BASE + 'accounts/api/register/',
    delete: API_BASE + 'accounts/api/user-delete/',

    // Notifications
    notifications_fcm: API_BASE + 'notifications/fcm/',

    // Custom
    organisations: `${API_BASE}organisation/list/`,
    organisation: `${API_BASE}organisation/`,
    user_organisations: `${API_BASE}organisation/my-organisations/`,
    organisation_user: `${API_BASE}organisation/user/`,
    organisation_users: `${API_BASE}organisation/users/`,

    data_issue: `${API_BASE}organisation/data/issue/`,
    data_issues: `${API_BASE}organisation/data/issues/`,

    data_issue_image: `${API_BASE}organisation/data/issue/%i/issue-image/`,

    data_asset_register: `${API_BASE}organisation/data/asset-register/`,
    data_asset_registers: `${API_BASE}organisation/data/asset-registers/`,

    data_asset_register_image: `${API_BASE}organisation/data/asset-register/%i/image/`,

    data_categories: `${API_BASE}organisation/data/categories/`,
    data_issues_types: `${API_BASE}organisation/data/issue-types/`,
    data_authority_types: `${API_BASE}organisation/data/authority-types/`,
    data_nature_of_accidents: `${API_BASE}organisation/data/nature-of-accidents/`,
    data_accident_classifications: `${API_BASE}organisation/data/accident-classifications/`,
    data_vehicle_types: `${API_BASE}organisation/data/vehicle-types/`,
    data_road_features: `${API_BASE}organisation/data/road-features/`,
    data_road_conditions: `${API_BASE}organisation/data/road-conditions/`,
    data_intersection_types: `${API_BASE}organisation/data/intersection-types/`,
    data_weather_conditions: `${API_BASE}organisation/data/weather-conditions/`,
    data_enroachment_types: `${API_BASE}organisation/data/enroachment-types/`,
    data_causes: `${API_BASE}organisation/data/causes/`,
    data_help_types: `${API_BASE}organisation/data/help-types/`,
    data_type_of_programs: `${API_BASE}organisation/data/type-of-programs/`,
    data_accident_type: `${API_BASE}organisation/data/accident-types/`,
    data_hazard_type: `${API_BASE}organisation/data/hazard-types/`,
    data_type_of_roads: `${API_BASE}organisation/data/type-of-roads/`,

    data_issue_action: `${API_BASE}organisation/data/issue/%i/action/`,
    dpr_entry_issue_action: `${API_BASE}organisation/data/dpr/entry/%i/action/`,

    stock_list: `${API_BASE}organisation/stock/stocks/`,
    stock_get: `${API_BASE}organisation/stock/stock/`,

    stock_log_list: `${API_BASE}organisation/stock/stock/logs/`,
    stock_log_get: `${API_BASE}organisation/stock/stock/log/`,

    stock_categories: `${API_BASE}organisation/stock/categories/`,
    stock_subcategories: `${API_BASE}organisation/stock/sub-categories/`,
    stock_uoms: `${API_BASE}organisation/stock/units-of-measurement/`,

    dpr_reports: `${API_BASE}organisation/data/dpr/reports/`,
    dpr_packages: `${API_BASE}organisation/data/dpr/packages/`,
    dpr_package_keys: `${API_BASE}organisation/data/dpr/package-keys/`,
    dpr_report_key: `${API_BASE}organisation/data/dpr/report-key/`,

    dpr_month: `${API_BASE}organisation/data/dpr/month/`,
    dpr_daily: `${API_BASE}organisation/data/dpr/daily/`,
    dpr_log_po: `${API_BASE}organisation/data/dpr-log-po/`,

    dpr_month_action: `${API_BASE}organisation/data/dpr/month/%i/action/`,
    dpr_log_action: `${API_BASE}organisation/data/dpr/log/%i/action/`,

    // dpr logs
    dpr_log: `${API_BASE}organisation/data/dpr/log/`,
    dpr_log_list: `${API_BASE}organisation/data/dpr/logs/`,
    dpr_log_image: `${API_BASE}organisation/data/dpr/log/%i/dpr-log-image/`,

    // dpr entry
    dpr_entry: `${API_BASE}organisation/data/dpr/entry/`,
    dpr_entry_list: `${API_BASE}organisation/data/dpr/entries/`,
    dpr_entry_image: `${API_BASE}organisation/data/dpr/entry/%i/dpr-entry-images/`,

    //create excel
    excel_create: `${API_BASE}organisation/data/excel/create/`,
    excel_list: `${API_BASE}organisation/data/excel/list/`,

    // safety program
    safety_program: `${API_BASE}organisation/data/safety-program/`,
    safety_programs: `${API_BASE}organisation/data/safety-programs/`,
    safety_program_action: `${API_BASE}organisation/data/safety-program/%i/action/`,
    safety_program_image: `${API_BASE}organisation/data/safety-program/%i/safety-program-image/`,

    entries_report: `${API_BASE}organisation/data/entries/report/`,

    //notification
    notifications: `${API_BASE}organisation/notification/list/`,
    notification: `${API_BASE}organisation/notification/`,
    unread_notification: `${API_BASE}organisation/notification/unread-notification/`,

    dashboard_stats_view1: `${API_BASE}organisation/stats/dashboard/view1/`,
    dashboard_stats_view2: `${API_BASE}organisation/stats/dashboard/view2/`,
    admin_dashboard_stats_view3: `${API_BASE}organisation/stats/admin/dashboard/view3/`,
    status_dashboard_data_issues: `${API_BASE}organisation/data/status-dashboard/issues`,

    // permission data
    role_list: `${API_BASE}organisation/admin/role/list/`,

    // sap po
    sap_po: `${API_BASE}organisation/sap/po/`,
    sap_po_list: `${API_BASE}organisation/sap/po/list/`,

    // master year
    master_year: `${API_BASE}master/year/`,
    master_item_group: `${API_BASE}master/item-group/`,
    master_lane: `${API_BASE}master/lane/`,
    master_uom: `${API_BASE}master/uom/`,
    master_side: `${API_BASE}master/side/`,
    master_vendor: `${API_BASE}master/vendor/`,
    purchase_order: `${API_BASE}master/purchase-order/`,
    purchase_order_detail: `${API_BASE}master/purchase-order-detail/`,
    master_budget: `${API_BASE}master/budget/`,
    master_item_sub_group: `${API_BASE}master/item-sub-group/`,

    // Reports
    report_budget_actual: `${API_BASE}master/report-budget-actual`,

    // DRP Transaction
    drp_transaction: `${API_BASE}master/drp-transaction/`,

    // Strip Chart
    strip_chart: `${API_BASE}master/strip-chart/`,
}

export default apiendpoints
